var beneficiaryAgreementController = function ($modalInstance, $injector) {

	var vm = this;
	var $translate = $injector.get('$translate');

	$translate(["app.beneficiary.buttons.continue"], function (translation) {
		vm.mainPageSubmitButtonName = translation["app.beneficiary.buttons.continue"]
	});

	vm.dismiss = function () {
		$modalInstance.dismiss('cancel');
	};

};

beneficiaryAgreementController.$inject = ['$modalInstance', '$injector'];
export default beneficiaryAgreementController;
